import axios from 'axios'
import { buildApiBaseUrl, installAuthInterceptor, setAxiosAuthHeader } from '@/api/clientConfig'

const axiosAdminApi = axios.create({
    baseURL: buildApiBaseUrl(process.env.VUE_APP_ADMIN_API), // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 30000, // request timeout
})
export const setAuthHeader = (token) => {
    setAxiosAuthHeader(axiosAdminApi, token)
}

installAuthInterceptor(axiosAdminApi, process.env.VUE_APP_ADMIN_API)

export default axiosAdminApi;
